import { Store } from 'src/store/index';

const findCustomerPictureId = (store: Store, assetId: string): string | null => {
  const images = store.gallery.images || [];
  const image = images.find((img) => String(img.sourcePictureId) === assetId || img.id === assetId);
  return image?.id || null;
};

export default findCustomerPictureId;
